import React, { useState, useEffect } from "react";
import {
  FormGroup,
  Row,
  Col,
  FormSelect,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "shards-react";
import styled from "styled-components";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import {
  SelectIndicatorsDatasetKeyin,
  SelectIndicatorsDatasetKeyinTabs,
  SelectIndicatorsDatasetKeyinYears,
  SelectAgencyPowerBi,
} from "shared/components";
import { Loading, KeyinAllTable } from "views/PowerbiSetting/components";
import useCurrentUser from "shared/hook/useCurrentUser";

const RowData = styled(Row)`
  margin-top: 10px;
  border-top: 1px solid #e1e5eb;
  padding-top: 20px;
`;

const showNotify = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "error":
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "warn":
      toast.warn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "info":
      toast.info(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    default:
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
  }
};

const PowerbiSettingAPI = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const { curruntUser } = useCurrentUser();
  const [api7Token, setApi7Token] = useState(null);
  const [api7qualificationType, setApi7qualificationType] = useState("");
  const [api7qualificationId, setApi7qualificationId] = useState(null);
  const [api7TypeReport, setApi7TypeReport] = useState(0);
  const [api7CurrentPage, setApi7CurrentPage] = useState(1);
  const [api7TotalPage, setApi7TotalPage] = useState(1);
  const [api7TotalItem, setApi7TotalItem] = useState(0);
  const [api7Result, setApi7Result] = useState(null);


  const [openModalExam, setOpenModalExam] = useState(false);
  const [dataExam, setDataExam] = useState(null);

  const [userType, setUserType] = useState(0);
  const [userId, setUserId] = useState(null);
  const [agencyId, setAgencyId] = useState(null);
  const [openAddyears, setOpenAddyears] = useState(false);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [tableTabSettingId, setTableTabSettingId] = useState(null);
  const [yearId, setyearId] = useState(null);


  const formatCurrency = number => {
    return number.toFixed(0).replace(/\d(?=(\d{3}))/g, '$&,');
  };

  const qualificationType = ["INDUSTRIAL", "AGRICULTURE", "SERVICE", "OTHER"];

  useEffect(() => {
    if (curruntUser) {
      setUserType(curruntUser.detail.userType);
      setAgencyId(curruntUser.detail.agencyId);
      setUserId(curruntUser.detail.userId);
    }
  }, [curruntUser]);

  var axios = require("axios");
  const loginApi = () => {
    setLoading(true);
    const data = JSON.stringify({
      params: {
        "ClientID" : "632d46490fdd8",
        "ClientSecret" :"026662a5a12d86bb7d87240c57edcca2"
      }
    });

    const config = {
      method: "post",
      url:`${baseUrl}/v1/setting-table/apilogin`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      },
      data: data,
    };

    axios(config)
      .then(function(response) {
        console.log(response.data.token)
        if (response.data.status === "000") {
          setApi7Token(response.data.token);
        } else {
          setApi7Token(null);
          showNotify("ไม่สามารถเข้าสู่ระบบได้", "error");
        }
        setLoading(false);
      })
      .catch(function(error) {
        console.log("loginApi", error);
        showNotify("ไม่สามารถเข้าสู่ระบบได้", "error");
        setApi7Token(null);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (api7TypeReport === 1) {
      getAllQualification();
    }
    else if(api7TypeReport === 2){
      getAllExamAround();
    }
    else if(api7TypeReport === 3){
      getQualificationbyType();
    }
    else if(api7TypeReport === 4){
      getItemQualification();
    }
  }, [api7CurrentPage]);

  const getAllQualification = () => {
    setApi7TypeReport(1);
    setLoading(true);
    const data = JSON.stringify({
      params: {
        token: api7Token,
        page : api7CurrentPage
      }
    });

    const config = {
      method: "post",
      url:`${baseUrl}/v1/setting-table/apiallqualification`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      data : data
    };

    axios(config)
      .then(function(response) {
        if(response.data.message == "พบข้อมูลคุณวุฒิในระบบ"){
          console.log("getAllQualification", response.data.result);
          setApi7TotalPage(response.data.result.page_all);
          setApi7CurrentPage(response.data.result.page_current);
          setApi7TotalItem(response.data.result.item_all);
          setApi7Result(response.data.result.item_list);
          setLoading(false);
        }
        else{
          showNotify(response.data.message, "error");
          setApi7Token(null);
          setLoading(false);
        }
      })
      .catch(function(error) {
        console.log(error);
        showNotify("ไม่สามารถดึงข้อมูลได้", "error");
        setApi7Token(null);
      });
  };

  const getAllExamAround = () => {
    setApi7TypeReport(2);
    setLoading(true);
    const data = JSON.stringify({
      params: {
        token: api7Token,
        page : api7CurrentPage
      }
    });

    const config = {
      method: "post",
      url:`${baseUrl}/v1/setting-table/apiallexamaround`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      data : data
    };

    axios(config)
      .then(function(response) {
        console.log("getAllExamAround", response.data);
        if(response.data.message == "พบข้อมูลรอบประเมินในระบบ"){
          setApi7TotalPage(response.data.result.page_all);
          setApi7CurrentPage(response.data.result.page_current);
          setApi7TotalItem(response.data.result.item_all);
          setApi7Result(response.data.result.item_list);
          setLoading(false);
        }
        else{
          showNotify(response.data.message, "error");
          setApi7Token(null);
          setLoading(false);
        }
      })
      .catch(function(error) {
        console.log(error);
        showNotify("ไม่สามารถดึงข้อมูลได้", "error");
        setApi7Token(null);
      });
  };

  const getQualificationbyType = (type) => {
    setApi7TypeReport(3);
    setLoading(true);
    const data = JSON.stringify({
      params: {
        token: api7Token,
        qualification : type
      }
    });

    const config = {
      method: "post",
      url:`${baseUrl}/v1/setting-table/apiqualification`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      data : data
    };

    axios(config)
      .then(function(response) {
        console.log("getQualificationbyType", response.data);
        if(response.data.message == "Found the qualification"){
          setApi7TotalPage(1);
          setApi7CurrentPage(1);
          setApi7TotalItem(0);
          setApi7Result(response.data.result);
          setLoading(false);
        }
        else{
          showNotify(response.data.message, "error");
          setApi7Token(null);
          setLoading(false);
        }
        
      })
      .catch(function(error) {
        console.log(error);
        showNotify("ไม่สามารถดึงข้อมูลได้", "error");
        setApi7Token(null);
      });
  };

  const getItemQualification = () => {
    setApi7TypeReport(4);
    setLoading(true);
    const data = JSON.stringify({
      params: {
        token: api7Token,
        page : api7qualificationId
      }
    });

    const config = {
      method: "post",
      url:`${baseUrl}/v1/setting-table/apiitemqualification`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      data : data
    };

    axios(config)
      .then(function(response) {
        console.log("getAllQualification", response.data);
        if(response.data.message == "พบข้อมูลคุณวุฒิในระบบ"){
          setApi7TotalPage(1);
          setApi7CurrentPage(1);
          setApi7TotalItem(0);
          setApi7Result(response.data.result);
          setLoading(false);
        }
        else{
          showNotify(response.data.message, "error");
          setApi7Token(null);
          setLoading(false);
        }
      })
      .catch(function(error) {
        console.log(error);
        showNotify("ไม่สามารถดึงข้อมูลได้", "error");
        setApi7Token(null);
      });
  };

  const nextPage = (page, total_page) => {
    setApi7CurrentPage(page + 1);
    setApi7TotalPage(total_page);
  };

  const onOpenModalExam = (data) =>{
    setOpenModalExam(true);
    setDataExam(data);
  }

  return (
    <Layout>
      <ToastContainer />
      {loading && <Loading />}
      <Row style={{ marginBottom: "30px" }}>
        <Col md="12">
          <h5>การดึงข้อมูลผ่าน API</h5>
        </Col>
        {
          api7Token != null && api7TypeReport != 0 && api7Result != null && (
            <Col md="12">
              <a onClick={() => {
                setApi7TypeReport(0);
                setApi7TotalPage(1);
                setApi7CurrentPage(1);
                setApi7TotalItem(0);
                setApi7Result(null);
              }} className="select"> {`<< กลับไปเลือกข้อมูล`}</a>
            </Col>
          )
        }
      </Row>
      
      {api7Token == null && (
        <RowData>
          <Col md="12">
            <p>
              ข้อมูลของตัวชี้วัด
              "มีมาตรฐานอาชีพและมาตรฐานฝีมือแรงงานด้านโลจิสติกส์ครอบคลุมทุกสาขา"
              สามารถใช้ API ได้ ต้องเข้าสู่่ระบบเพื่อดึงข้อมูล
            </p>
            <Button theme="success" onClick={() => loginApi()}>
              เข้าสู่ระบบดึงข้อมูล API
            </Button>
          </Col>
        </RowData>
      )}

      {api7Token != null && api7TypeReport == 0 && (
        <RowData>
          <Col md="12">
            <p style={{ marginBottom: 10 }}>
              ข้อมูลของ ตัวชี้วัด
              "มีมาตรฐานอาชีพและมาตรฐานฝีมือแรงงานด้านโลจิสติกส์ครอบคลุมทุกสาขา"
              มีดังนี้
            </p>
          </Col>

          <Col md="12" style={{ marginBottom: 20 }}>
            <div className="table-responsive">
              <table className="table mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col" style={{ minWidth: "50px" }}></th>
                    <th scope="col" style={{ minWidth: "260px" }}>
                      ชื่อข้อมูล
                    </th>
                    <th scope="col" style={{ minWidth: "145px" }}>
                      กดเพื่อรับข้อมูล
                    </th>
                  </tr>
                </thead>
                <tbody className="table-middle">
                      <tr>
                        <td>1</td>
                        <td>ข้อมูลคุณวุฒิทั้งหมด</td>
                        <td>
                          <Button theme="success" onClick={() => getAllQualification()}>
                            รับข้อมูลคุณวุฒิทั้งหมด
                          </Button>
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>ข้อมูลรอบประเมินทั้งหมด</td>
                        <td>
                          <Button theme="success" onClick={() => getAllExamAround()}>
                          รับข้อมูลรอบประเมินทั้งหมด
                          </Button>
                        </td>
                      </tr>
                </tbody>
              </table>
            </div>
          </Col>
          {/* <Col md="12" style={{ marginBottom: 20 }}>
            <p style={{ marginBottom: 10 }}>3. ข้อมูลคุณวุฒิตามประเภท</p>
            <Button
              style={{ marginBottom: 10 }}
              theme="success"
              onClick={() => getQualificationbyType("INDUSTRIAL")}
            >
              กดเพื่อรับข้อมูลคุณวุฒิ "INDUSTRIAL"
            </Button>{" "}
            <br />
            <Button
              style={{ marginBottom: 10 }}
              theme="success"
              onClick={() => getQualificationbyType("AGRICULTURE")}
            >
              กดเพื่อรับข้อมูลคุณวุฒิ "AGRICULTURE"
            </Button>{" "}
            <br />
            <Button
              style={{ marginBottom: 10 }}
              theme="success"
              onClick={() => getQualificationbyType("SERVICE")}
            >
              กดเพื่อรับข้อมูลคุณวุฒิ "SERVICE"
            </Button>{" "}
            <br />
            <Button
              style={{ marginBottom: 10 }}
              theme="success"
              onClick={() => getQualificationbyType("OTHER")}
            >
              กดเพื่อรับข้อมูลคุณวุฒิ "OTHER"
            </Button>
          </Col>
          <Col md="12" style={{ marginBottom: 50 }}>
            <p style={{ marginBottom: 10 }}>4. รายละเอียดคุณวุฒิ</p>
            <Button theme="success" onClick={() => getItemQualification()}>
              กดเพื่อรับข้อมูลรายละเอียดคุณวุฒิ
            </Button>
          </Col> */}
        </RowData>
      )}

      {/* ข้อมูลคุณวุฒิทั้งหมด */}
      {api7Token != null && api7TypeReport === 1 && api7Result != null &&(
          <Row>
            <Col md="12">
              <h5>
               <small>ข้อมูลคุณวุฒิทั้งหมด จำนวนทั้งหมด</small> {formatCurrency(api7TotalItem)} <small>รายการ</small>

                <span style={{float:'right'}}> <small>หน้า</small> {api7CurrentPage} <small>จาก</small> {api7TotalPage}</span>
              </h5>
            </Col>
            <Col md="12">
              <div className="table-responsive">
                <table className="table mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" style={{ minWidth: "50px" }}></th>
                      <th scope="col" style={{ minWidth: "60px" }}>
                        level
                      </th>
                      <th scope="col" style={{ minWidth: "145px" }}>
                        standard_type
                      </th>
                      <th scope="col" style={{ minWidth: "160px" }}>
                        standard_group
                      </th>
                      <th scope="col" style={{ minWidth: "200px" }}>
                        tier1
                      </th>
                      <th scope="col" style={{ minWidth: "200px" }}>
                        tier2
                      </th>
                      <th scope="col" style={{ minWidth: "200px" }}>
                        tier3
                      </th>
                    </tr>
                  </thead>
                  <tbody className="table-middle">
                    {api7Result != null && api7Result.length > 0 ? (
                      api7Result.map((item, key) => (
                        <tr>
                          <td style={{verticalAlign : 'top'}}>{((api7CurrentPage - 1)*50) + key + 1}</td>
                          <td style={{verticalAlign : 'top'}}>{item.level_code}</td>
                          <td style={{verticalAlign : 'top'}}>
                            {/* [ {item.standard_type_code} ] */} {item.standard_type_title}
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.standard_group_code}<br/>
                            <small>{item.standard_group_title}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.tier1_id}( {item.tier1_code} ):<br/>
                            <small>{item.tier1_title}{" "}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.tier2_id}({item.tier2_code}):<br/>
                            <small>{item.tier2_title}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.tier3_id}:{" "}{item.tier3_title}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>ยังไม่มีข้อมูลคุณวุฒิทั้งหมด</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
      )}

      {/* ข้อมูลรอบประเมินทั้งหมด */}
      {api7Token != null && api7TypeReport === 2 && api7Result != null &&(
          <Row>
            <Col md="12">
              <h5>
                <small>ข้อมูลรอบประเมินทั้งหมด จำนวนทั้งหมด</small> {formatCurrency(api7TotalItem)} <small>รายการ</small>

                <span style={{float:'right'}}> <small>หน้า</small> {api7CurrentPage} <small>จาก</small> {api7TotalPage}</span>
              </h5>
            </Col>
            <Col md="12">
              <div className="table-responsive">
                <table className="table mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" style={{ minWidth: "50px" }}></th>
                      <th scope="col" style={{ minWidth: "120px" }}>
                        exam_no
                      </th>
                      <th scope="col" style={{ minWidth: "300px" }}>
                        หน่วยงาน
                      </th>
                      <th scope="col" style={{ minWidth: "300px" }}>
                       qualification
                      </th>
                      <th scope="col" style={{ minWidth: "300px" }}>
                      สถานที่ประเมิน
                      </th>
                      <th scope="col" style={{ minWidth: "250px" }}>
                      วันที่เปิดรับสมัคร
                      </th>
                      <th scope="col" style={{ minWidth: "130px" }}>
                      ดูรายละเอียด
                      </th>
                    </tr>
                  </thead>
                  <tbody className="table-middle">
                    {api7Result != null && api7Result.length > 0 ? (
                      api7Result.map((item, key) => (
                        <tr>
                          <td style={{verticalAlign : 'top'}}>{((api7CurrentPage - 1)*50) + key + 1}</td>
                          <td style={{verticalAlign : 'top'}}>{item.exam_no}</td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.org_code}<br/>
                            <small>{item.org_name}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.qualification_id}:<br/>
                            <small>{item.qualification_name}{" "}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            {item.site_address_name} :<br/>
                            <small>{item.site_address_location}</small>
                          </td>
                          <td style={{verticalAlign : 'top'}}>
                            <small>{moment(item.open_date).format("DD/MM/YYYY")}{" "}-{" "}{moment(item.close_date).format("DD/MM/YYYY")} </small>
                          </td>
                          <td style={{verticalAlign : 'top' }}>
                            <Button theme="success" onClick={() => onOpenModalExam(item)}>
                             <i class="material-icons">search</i>
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>ยังไม่มีข้อมูลคุณวุฒิทั้งหมด</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
      )}

      {/* ReactPaginate */}
      {api7Token != null && api7TypeReport !== 0 && api7Result != null &&(
          <Row>
            <Col md="12" style={{ textAlign: "right" }}>
              <ReactPaginate
                pageCount={api7TotalPage}
                forcePage={api7CurrentPage - 1}
                containerClassName="pagination"
                nextLabel=">"
                previousLabel="<"
                onPageChange={({ selected }) => {
                  nextPage(selected, api7TotalPage);
                }}
              />
            </Col>
          </Row>
      )}

      {
        openModalExam && (
          <Modal
          size="lg" 
          open={openModalExam}
          toggle={()=> setOpenModalExam(false)}
        >
          <ModalHeader>{dataExam.exam_no}</ModalHeader>
          <ModalBody>
          <div className="table-responsive">
              <table className="table mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col" style={{ minWidth: "50px" }}></th>
                    <th scope="col" style={{ minWidth: "260px" }}>
                      ขั้นตอนการประเมิน
                    </th>
                    <th scope="col" style={{ minWidth: "100px" }}>
                      วัน-เวลาเริ่ม
                    </th>
                    <th scope="col" style={{ minWidth: "100px" }}>
                      วัน-เวลาสิ้นสุด
                    </th>
                  </tr>
                </thead>
                <tbody className="table-middle">
                  {
                    dataExam.assessment_list.map((item, key) => (
                      <tr>
                        <td>{key + 1}</td>
                        <td>
                          {item.method_name || "การประเมิน"}
                        </td>
                        <td>
                          {`${moment(item.start_date).format("DD/MM/YYYY")} ${item.start_time || ''}`} 
                        </td>
                        <td>
                          {`${moment(item.end_date).format("DD/MM/YYYY")} ${item.end_time || ''}`} 
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              theme="secondary"
              onClick={()=> setOpenModalExam(false)}
            >
              ปิด
            </Button>
          </ModalFooter>
        </Modal>
        )
      }
        
    </Layout>
  );
};

export default PowerbiSettingAPI;
